import {CommonModule} from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import {ToastMessageInterface} from "../../interfaces";
import {ToastsService} from "../../services";
import {UxToastMessage} from "@trumpf/ux.ui-angular-standalone";

@Component({
    selector: "mtc-toasts-host",
    imports: [CommonModule, UxToastMessage],
    templateUrl: "./toasts-host.component.html",
    styleUrl: "./toasts-host.component.scss"
})
export class ToastsHostComponent implements OnInit {
  private readonly toastsService = inject(ToastsService);

  public toasts: Array<ToastMessageInterface> = [];

  public ngOnInit(): void {
    this.toastsService.getToastsObservable().subscribe(next => {
      this.toasts = next;
    });
  }
}
